import axios from '../axios';
import {GET_USER_LIST, EXPORT_USERS} from "../constants/ApiConstants";
import * as apiTypes from "../constants/ApiConstants";
import {requestErrored, updateState} from "../actions/CommonActions";
import * as types from "../constants/ActionTypes";
import {setSelectedSoldTos} from "../actions/InvoiceActions";
import * as validationTypes from "../constants/ValidationConstants";
import {saveAs} from 'file-saver';

export function getUserList(status = "", profile = "", search = "", page = 1) {
  return axios.get(GET_USER_LIST, {params: {status, profile, search, page}}).then((response) => {
    return {
      data: response.data,
      total: response.headers['x-page-total-items']
    };
  });
}


export function exportUserList() {
  return axios.get(EXPORT_USERS, {responseType: 'blob', }).then((response) => {
    saveAs(
      response.data,
      "Users.xlsx"
    );
  });
}

export function getUser(userId) {
  return () => {
    return axios.get(`/api/users/${userId}`).then((response) => {
      return response.data;
    });
  }
}

export function saveUser(user) {
  user.userProfileId = parseInt(user.userProfileId);
  user.profile = null; // passing a profile object will cause problems on .net side
  if (user.UserId) {
      return axios.put(`/api/users/${user.UserId}`, user).then((response) => {
      return response.data;
    });
  } else {
    return axios.post('/api/users', user).then((response) => {
      return response.data;
    });
  }
}

// export function getProfiles() {
//   return axios.get('/api/profiles').then((response) => {
//     return response.data;
//   })
// }

function updateUserSapAccount(userId, account) {
    return axios.put(`/api/users/${userId}/accounts/${account.AccountId}`, account).then((response) => {
    return response.data;
  });
}

function createUserSapAccount(userId, account) {
  return axios.post(`/api/users/${userId}/accounts`, account).then((response) => {
    return response.data;
  });
}

export function deleteUserSapAccount(userId, account) {
    return axios.delete(`/api/users/${userId}/accounts/${account.AccountId}`).then((response) => {
    return response.data;
  });
}

export function saveUserSapAccount(userId, account) {
    if (account.AccountId && account.AccountId > 0) {
    return updateUserSapAccount(userId, account);
  }
  return createUserSapAccount(userId, account);
}

export function getUserSapAccounts(userId) {
  return axios.get(`/api/users/${userId}/accounts`).then((response) => {
    return response.data;
  });
}

export function getUserByInvite(invite) {
  return axios.get(`/api/users/invite/${invite}`).then((response) => {
    return response.data;
  });
}

export function getUserByPasswordReset(id) {
  return axios.get(`/api/users/password-reset/${id}`).then((response) => {
    return response.data;
  });
}

export function completeRegistration(inviteId, password, confirmPassword) {
  return axios.post(`/api/token/complete-registration`, {inviteId, password, confirmPassword}).then((response) => {
    return response.data;
  });
}

export function passwordResetRequest(requestForm) {
  return axios.post(`/api/users/password-reset-request`, requestForm).then((response) => {
    return response.data;
  });
}

export function completePasswordReset(id, password, confirmPassword) {
  return axios.post(`/api/token/complete-password-reset`, {id, password, confirmPassword}).then((response) => {
    return response.data;
  });
}

export function getExclusionList(userId){
  return axios.get(`/api/users/${userId}/exclusions`).then((response) => {
    if(response.status === "404"){
      throw("Cold not find exclusion list.");
    }
    return response.data;
  });
}

export function updateExclusionList(userId, list){
  return axios.put(`/api/users/${userId}/exclusions`, list).then((response) => {
    return response.data;
  });
}

export function validateAccount(data){
  return axios.put(`/api/users/account/validate`, data).then((response) =>{
    return response.data; 
  });
}


export function getUserAccounts() {
  return axios.get(`/api/token/auto-register/accounts`).then((response) => {
    return response.data;
  })
}

export function registerUser(form){
  return axios.post(`/api/token/auto-register/user`, form).then((response) => {
    return response.data;
  });
}
export function confirmAccount(token){
  return axios.post(`/api/token/auto-register/user-confirm/${token}`,{}).then((response) => {
    return response.data;
  })
}

export function deleteUser(userId){
  return axios.delete(`/api/users/${userId}`,{}).then((response) => {
    return response.data;
  })
}

export function resendConfirmation(email){
  return axios.put(`/api/token/auto-register/resend-confirmation`,{}).then((response) => {
    return response.data;
  });
}
